import { Component, ViewChild, ElementRef } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { TaskActionsHistoryComponent } from '../task-actions-history/task-actions-history.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';

@Component({
  selector: 'app-overalldashboard',
  templateUrl: './overalldashboard.component.html',
  styleUrls: ['./overalldashboard.component.scss']
})
export class OveralldashboardComponent {
  isProcessing = true;
  getQmsCrVwDetails: any = [];
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  dateTimePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY HH:mm:ss',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public message: messageService, private readonly elem: ElementRef, public qmsservice: qmsService, public taskActionsHistoryComponent: TaskActionsHistoryComponent,
  ) {
    this.message.breadcrumbData.secondLevel = "Dashboard" + " > " + this.qmsservice.groupNameAndValue[0]?.displayExp;;
    this.message.breadcrumbData.thirdLevel = null;
    this.message.breadcrumbData.fourthLevel = null;
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;
  openGroupMethod() {
    this.topNavigationComponent.opengroupPopup();
  }
}
